<template>
  <div>
    <!-- 社区工单管理 -->
    <el-scrollbar>
      <el-form
        :inline="true"
        :model="filters"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        :size="size"
      >
      <!-- <el-form-item label="订单编号:">
        <el-input style="width:160px" v-model.trim="filters.orderNo" auto-complete="off" placeholder="请输入老人姓名"></el-input>
      </el-form-item> -->
        <el-form-item label="老人姓名:">
          <el-input style="width:150px" v-model.trim="filters.oldmanName" auto-complete="off" placeholder="请输入老人姓名"></el-input>
        </el-form-item>
        <el-form-item label="服务人员:">
          <el-input style="width:150px" v-model.trim="filters.userNameGet" auto-complete="off" placeholder="请输入服务人员姓名"></el-input>
        </el-form-item>
        <el-form-item label="所属乡镇:" v-if="areaList!=null && areaList.length>0">
          <el-select v-model="filters.communityList" style="width:200px" multiple placeholder="请选择">
            <el-option
              v-for="item in areaList"
              :key="item.dictName"
              :label="item.dictName"
              :value="item.dictName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select
            v-model="filters.orderStatus"
            clearable
            style="width:150px"
            placeholder="请选择订单状态"
          >
            <el-option
              v-for="item in orderChoose"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="时间范围:">
          <el-date-picker
            :editable="false"
            v-model="filters.timevalue"
            unlink-panels
            type="daterange"
            style="width:220px"
            :picker-options="pickerOptions2"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable
          >
          </el-date-picker>
        </el-form-item>

        <!-- <el-form-item label="工单来源">
          <el-select
            v-model="filters.orderSource"
            clearable
            style="width:200px"
            placeholder="请选择工单来源"
          >
            <el-option
              v-for="item in orderSourceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->

        
        
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            plain
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-plus" type="warning" plain @click="handleAdd"
            >新增</el-button
          >
          <el-button type="info" @click="downLoad" icon="el-icon-upload" plain>导出</el-button>
        </el-form-item>
      </el-form>
      <div class="filtersposition"></div>
    </el-scrollbar>

    <!-- 表格 -->
    <el-row>
      <el-table
        :data="tableData"
        class="worktable"
        style="width: 100%"
        :row-key="getRowKeys"
        :expand-row-keys="expands"
        :row-style="tableRowStyle"
        :cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
        :header-cell-style="tableHeaderColor"
        @expand-change="expandChange">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-row>
                <el-col :span="4">
                  <el-form-item label="老人姓名：">
                    <span class="height40">{{ props.row.oldmanName }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="4">
                  <el-form-item label="手机号：">
                    <span class="height40">{{ props.row.oldmanPhone }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="5">
                  <el-form-item label="老人身份证：">
                    <span class="height40">{{ props.row.oldmanCard }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="5">
                  <el-form-item label="社区：">
                    <span class="height40">{{ props.row.community }}</span>
                  </el-form-item>
                </el-col> 
                <el-col :span="6">
                  <el-form-item label="服务位置：">
                    <span class="height40">{{ props.row.serviceAddress }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="下单人姓名：">
                    <span class="height40">{{ props.row.userNamePut }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="4">
                  <el-form-item label="下单手机号：">
                    <span class="height40">{{ props.row.userPhonePut }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="5">
                  <el-form-item label="接单人姓名：">
                    <span class="height40">{{ props.row.userNameGet }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="5">
                  <el-form-item label="接单手机号：">
                    <span class="height40">{{ props.row.userPhoneGet }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="陪同人员:">
                    <span class="height40">{{ props.row.nurseName || '-' }}</span>
                  </el-form-item>
                </el-col>

                <el-col :span="4">
                  <el-form-item label="服务时长：">
                    <span class="height40">{{ props.row.totalDuration }}分钟</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="4">
                  <el-form-item label="订单备注：">
                    <span class="height40">{{ props.row.remark }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="服务开始时间：">
                    <span class="height40">{{ props.row.serviceStartTime }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="服务结束时间：">
                    <span class="height40">{{ props.row.serviceEndTime }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="6">
                  <el-form-item label="异常原因：">
                    <span class="height40">{{ props.row.abnormalReason }}</span>
                  </el-form-item>
                </el-col>  
              </el-row>
              <el-row v-for="item2 in props.row.serviceOrderItemList" :key="item2.projectName">
                <el-col :span="4">
                  <el-form-item label="服务项目名称：">
                    <span class="height40">{{ item2.projectName }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="4">
                  <el-form-item label="项目联级：">
                    <span class="height40">{{ item2.projectLabel }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="项目类别：">
                    <span class="height40">{{ item2.catalogName }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="5">
                  <el-form-item label="项目描述：">
                    <span class="height40">{{ item2.projectRemark }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="6">
                  <el-form-item label="项目金额：">
                    <span class="height40">{{ item2.price + getCostTypeStr(item2.costType) +" X"+item2.number }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-for="item2 in props.row.omcServiceOrderContents" :key="item2.id">
                <el-col :span="4">
                  <el-form-item label="服务流程：">
                    <span class="height40">{{ formatStatus2(item2.type) }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="4">
                  <el-form-item label="流程信息:">
                    <span class="height40">{{ item2.message }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="操作时间：">
                    <span class="height40">{{ item2.createdTime }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="5">
                  <el-form-item label="定位信息：">
                    <span class="height40">{{ item2.serviceAddress }}</span>
                  </el-form-item>
                </el-col>  
                <el-col :span="6">
                  <el-form-item label="服务图片：">
                    <div class="img_box" v-if="item2.imgUrls.length>10">
                      <el-image class="img" :key="imgurl" v-for="imgurl in item2.imgUrls.split(',')" :preview-src-list="item2.imgUrls.split(',')" :src="imgurl"/>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          :index="indexMethod"
          width="60">
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="工单编号"
          show-overflow-tooltip
          min-width="93"
          align="center"
        ></el-table-column>
        <!-- <el-table-column
          prop="orderSourceText"
          label="工单来源"
          min-width="80"
          show-overflow-tooltip
          :formatter="formatSource"
          align="center"
        ></el-table-column> -->
        <el-table-column
          prop="oldmanName"
          label="老人姓名"
          min-width="80"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        
        <el-table-column
          prop="serviceContent"
          label="服务内容"
          min-width="100"
          show-overflow-tooltip
          align="center"
        >
        <template slot-scope="scope">
          <p v-if="scope.row.packageName != null && scope.row.packageName != ''">{{scope.row.packageName}}</p>
          <p v-else>{{scope.row.serviceContent}}</p>
        </template>
        </el-table-column>

        <el-table-column label="社区(村镇)" prop="community" min-width="80" align="center"></el-table-column>
        <el-table-column label="服务人员" prop="userNameGet" min-width="80" align="center"></el-table-column>
        <el-table-column label="订单类型" prop="specialName" min-width="80" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.specialName == '市场服务'">{{scope.row.isPayed==1?'已支付':'待支付'}}</p>
            <p v-else>{{scope.row.specialName}}</p>
          </template>
        </el-table-column>

        <el-table-column label="服务完成时间" prop="serviceEndTime" min-width="120" align="center" show-overflow-tooltip></el-table-column>

        <!-- <el-table-column label="投诉状态" prop="complaintStatus" min-width="80" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.complaintStatus == 1" class="red">投诉中</p>
            <p v-else-if="scope.row.complaintStatus == 2">已处理</p>
            <p v-else>无投诉</p>
          </template>
        </el-table-column> -->
        <!-- serviceEndTime -->
        <el-table-column label="是否异常" prop="isAbnormal" min-width="80" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.isAbnormal == 1" class="red">工单异常</p>
            <p v-else>正常</p>
          </template>
        </el-table-column>

        <el-table-column
          prop="orderStatus"
          label="服务状态"
          min-width="80"
          :formatter="formatStatus"
          align="center"
        ></el-table-column>
        
        <el-table-column label="操作" align="center" width="190">
          <template slot-scope="scope">
            <div>
                <el-button
                size="mini"
                plain
                type="success"
                @click="handleDetail(scope.row)"
                >详情</el-button>
              
              <el-dropdown style="margin-left: 10px;">
                <el-button
                      size="mini"
                      plain
                      type="warning"
                      >更多
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="scope.row.orderStatus == 0 || scope.row.orderStatus == 6">
                    <el-button
                      size="mini"
                      plain
                      style="margin: 2px;"
                      type="success"
                      @click="handleDistributeMnually(scope.row)"
                      >服务派单</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item v-else-if="scope.row.orderStatus == 5">
                    <el-button
                      type="success"
                      size="mini"
                      plain
                      style="margin: 2px;"
                      @click="handlesure(scope.row)"
                      >服务确认</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.orderStatus != 7">
                    <el-button
                      size="mini"
                      plain
                      style="margin: 2px;"
                      type="danger"
                      @click="handleCancel(scope.row)"
                      >服务取消</el-button
                    >
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
             
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, prev, pager, next"
        :total="total"
        :page-size="pageSize"
        align="center"
        class="fenye"
      ></el-pagination>
    </el-row>

     <!-- 工单详情 -->
     <el-dialog
     title="订单详情"
     :visible.sync="orderDetailVisible"
     width="820px"
   >
     <el-form
       ref="manualDataForm"
       :inline="true"
       :model="orderDetail"
       label-width="100px"
     >
     <el-row>
      <el-col>
        <div style="background: rgb(64, 158, 255);width:100%;padding: 5px;">
          <p style="margin-left: 22px;font-size: 17px;color: rgb(255, 255, 255);">订单信息</p>
        </div>
      </el-col>
      <el-col :span="8">
        <el-form-item label="服务长者:">
          <span class="height40">{{ orderDetail.oldmanName }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="服务护工:">
          <span class="height80">{{ orderDetail.userNameGet }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="陪同护工:">
          <span class="height80">{{ orderDetail.nurseName }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="服务地点:">
          <el-tooltip class="item" effect="dark" :content="orderDetail.serviceAddress">
            <span class="height80">{{ orderDetail.serviceAddress}}</span>
          </el-tooltip>
        
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="服务内容:">
          <span class="height80">{{ orderDetail.packageName||orderDetail.serviceContent }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="服务时长:">
          <span class="height80">{{ orderDetail.totalDuration||'' }}</span>
        </el-form-item>
      </el-col>

      <el-col v-if="orderDetail.omcServiceOrderEvaluates!=null && orderDetail.omcServiceOrderEvaluates.length>0">
        <div style="background: rgb(64, 158, 255);width:100%;padding: 5px;">
          <p style="margin-left: 22px;font-size: 17px;color: rgb(255, 255, 255);">服务评价</p>
        </div>
      </el-col>
      <el-col v-if="orderDetail.omcServiceOrderEvaluates!=null && orderDetail.omcServiceOrderEvaluates.length>0" :span="8">
        <el-form-item label="评价人:">
          <span class="height40">{{ orderDetail.omcServiceOrderEvaluates[0].creator }}</span>
        </el-form-item>
      </el-col>
      <el-col v-if="orderDetail.omcServiceOrderEvaluates!=null && orderDetail.omcServiceOrderEvaluates.length>0" :span="8">
        <el-form-item label="评价内容:">
          <span class="height80">{{ orderDetail.omcServiceOrderEvaluates[0].evaluate }}</span>
          <span class="height80">
            <el-rate
              v-model="orderDetail.omcServiceOrderEvaluates[0].score"
              disabled
              disabled-void-color='#cccccc'
              >
            </el-rate>
          </span>
        </el-form-item>
      </el-col>
      <el-col v-if="orderDetail.omcServiceOrderEvaluates!=null && orderDetail.omcServiceOrderEvaluates.length>0" :span="8">
        <el-form-item label="评价照片:">
          <span class="height80">
            <el-image style="width: 50px;height: 50px;" :preview-src-list="[orderDetail.omcServiceOrderEvaluates[0].evaluatePicture]" :src="orderDetail.omcServiceOrderEvaluates[0].evaluatePicture"/>
          </span>
        </el-form-item>
      </el-col>

      <el-col>
        <div style="background: rgb(64, 158, 255);width:100%;padding: 5px;">
          <p style="margin-left: 22px;font-size: 17px;color: rgb(255, 255, 255);">服务信息</p>
        </div>
      </el-col>
      <el-col :span="8">
        <el-form-item label="订单状态:">
          <span class="height80">{{ formatStatus(orderDetail) }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="是否异常:">
          <span class="height80">{{ orderDetail.isAbnormal==1?'有异常':'无' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="异常信息:">
          <el-tooltip class="item" effect="dark" :content="orderDetail.abnormalReason">
            <span class="height80">{{ orderDetail.abnormalReason||''}}</span>
          </el-tooltip>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="服务开始时间:">
          <span class="height80">{{ orderDetail.serviceStartTime||'' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="服务结束时间:">
          <span class="height80">{{ orderDetail.serviceEndTime||'' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="打卡地点:">
          <span class="height80" >
            <el-link type="primary" @click="showmap(orderDetail)">{{ orderDetail.signAddress||'未知地名' }}</el-link>
          </span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="开始图片：">
          <div class="img_box" v-if="orderDetail.imgUrls1!=null && orderDetail.imgUrls1.length >0">
            <el-image class="img" :key="imgurl" v-for="imgurl in orderDetail.imgUrls1" :preview-src-list="orderDetail.imgUrls1" :src="imgurl"/>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="服务中图片：">
          <div class="img_box" v-if="orderDetail.imgUrls3!=null && orderDetail.imgUrls3.length >0">
            <el-image class="img" :key="imgurl" v-for="imgurl in orderDetail.imgUrls3" :preview-src-list="orderDetail.imgUrls3" :src="imgurl"/>
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="结束图片：">
          <div class="img_box" v-if="orderDetail.imgUrls2!=null && orderDetail.imgUrls2.length >0">
            <el-image class="img" :key="imgurl" v-for="imgurl in orderDetail.imgUrls2" 
            :preview-src-list="orderDetail.imgUrls2" :src="imgurl"/>
          </div>
        </el-form-item>
      </el-col>
     </el-row>
       
     </el-form>
     <div slot="footer" class="dialog-footer" align="center">
       <el-button type="primary" @click="orderDetailVisible = false"
         >确 定</el-button
       >
     </div>
   </el-dialog>

    <!-- 新增工单 -->
    <el-dialog
      title="新增工单"
      :visible.sync="addOrderDialogVisible"
      width="600px"
      style="margin-top:-10vh"
      :close-on-click-modal="false"
    >
      <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="dataFormRules"
        label-width="150px"
      >
        <el-form-item label="老人姓名:" prop="oldmanName">
          <el-autocomplete
            v-model.trim="dataForm.oldmanName"
            auto-complete="off"
            placeholder="模糊搜索老人姓名"
            clearable
            style="width: 80%"
            :fetch-suggestions="querySearchAsync"
            @select="handleOlderSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="身份证号码:">
          <span class="height40">{{ orderInfo.oldIdCard }}</span>
        </el-form-item>
        <el-form-item label="电话号码:">
          <span class="height40">{{ orderInfo.oldPhone }}</span>
        </el-form-item>
        <el-form-item label="社区:">
          <span class="height40">{{ orderInfo.community }}</span>
        </el-form-item>
        <el-form-item label="服务地址:" prop="serviceAddress">
          <el-input
            v-model.trim="dataForm.serviceAddress"
            placeholder="选择服务地址"
            style="width: 80%"
            @focus="focusServiceAddress"
          ></el-input>
        </el-form-item>
        <el-form-item label="预约服务时间:">
          <el-col :span="9">
            <el-form-item prop="date1">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                v-model="dataForm.date1"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="1"> <span style="margin-left: 4px">_</span> </el-col>
          <el-col :span="9">
            <el-form-item prop="date2">
              <el-time-picker
                placeholder="选择时间"
                v-model="dataForm.date2"
                style="width: 100%"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
              ></el-time-picker>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label="选择服务类别:" required>
          <el-cascader
            v-model="dataForm.catalogId"
            style="width: 80%"
            @change="handleCatalogChange"
            :show-all-levels="false"
            placeholder="请选择服务类别"
            :options="secondServerList">
          </el-cascader>
        </el-form-item>
        <el-form-item label="选择服务项目:" required>
          <el-select
            placeholder="请选择服务项目"
            style="width: 80%"
            v-model="dataForm.projectId"
          >
            <el-option
              v-for="item in projectItem"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="备注:" prop="remark">
          <el-input
            type="textarea"
            v-model="dataForm.remark"
            style="width: 80%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="addOrderDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAddOrderForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 弹出选择 -->
    <el-dialog
      title="选择商品"
      :visible.sync="dialogFormVisible"
      width="500px"
      style="margin-top:-10vh"
      :close-on-click-modal="false"
    >
      <el-table
        ref="multipleTable"
        :data="goodList"
        @selection-change="handleSelectionChange"
        :show-header="false"
        @select="goodSelect">
        <el-table-column type="selection" width="40" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="名称"
          prop="merchandiseName"
          show-overflow-tooltip
          width="120"
        ></el-table-column>
        <el-table-column
          label="价格"
          prop="unitPrice"
          width="90"
        ></el-table-column>
        <el-table-column label="类型" prop="unit" width="60">
          <template slot-scope="scope">
            <span v-if="scope.row.unit == 0">元/次</span>
            <span v-else-if="scope.row.unit == 1">元/月</span>
            <span v-else-if="scope.row.unit == 2">元/小时</span>
            <span v-else-if="scope.row.unit == 3">元/张</span>
            <span v-else-if="scope.row.unit == 4">元/件</span>
          </template>
        </el-table-column>
        <el-table-column prop="number" label="数量">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.number"
              size="mini"
              plain
              controls-position="right"
              :min="1"
              :max="99"
              :precision="0"
            ></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <div
        slot="footer"
        class="dialog-footer"
        style="text-align: center; margin-top: 10px"
      >
        <el-button
          @click.native="dialogFormVisible = false"
          style="display: inline"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click.native="selectGoods"
          style="display: inline"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 手动派单 -->
    <el-dialog
      title="手动派单"
      :visible.sync="manualDeliveryDialogVisible"
      width="500px"
    >
      <el-form
        ref="manualDataForm"
        :model="manualDataForm"
        :rules="manualDataFormRules"
        label-width="150px"
      >
        <el-form-item label="老人姓名:">
          <span class="height40">{{ manualDataForm.oldmanName }}</span>
        </el-form-item>
        <el-form-item label="电话号码:">
          <span class="height40">{{ manualDataForm.oldPhone }}</span>
        </el-form-item>
        <el-form-item label="服务地址:">
          <span class="height40">{{ manualDataForm.serviceAddress }}</span>
        </el-form-item>
        <el-form-item label="服务项目:">
          <span class="height40">{{ manualDataForm.serviceContent }}</span>
        </el-form-item>
        <el-form-item label="服务金额:">
          <span class="height40">{{ manualDataForm.total }}</span>
        </el-form-item>
        <el-form-item label="服务人员:" prop="userIdGet">
          <el-select
            placeholder="请选择服务人员"
            v-model="manualDataForm.userIdGet"
            @change="changeServicePeople">
            <el-option
              v-for="item in servicePersonnelList"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input
            type="textarea"
            v-model="manualDataForm.remark"
            style="width: 70%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="manualDeliveryDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="submitManualDataForm"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 家庭地址设置 -->
    <el-dialog
      class="el-dialog-map"
      title="打卡地址及老人地址"
      width="640px"
      :visible.sync="dialogFormVisibleSafe"
    >
      <div class="oldmanmap">
        <div id="container" ref="amap" class="map"></div>
      </div>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="dialogFormVisibleSafe=false">确定</el-button>
      </div>
    </el-dialog>

    <!-- 在线支付 -->
    <el-dialog
      title="在线支付"
      :visible.sync="manualOperationRechargeDialogVisible"
      width="50%"
      center
      top="15vh"
      @close="resetManualOperationRechargeForm('manualOperationRechargeForm')"
      :close-on-click-modal="false"
    >
      <el-form
        :model="manualOperationRecharge"
        ref="manualOperationRechargeForm"
        label-width="95px"
        :rules="manualOperationRechargeRules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item prop="orderNo" label="工单编号:" :disabled="true">
              <span class="height40">
                {{ manualOperationRecharge.orderNo }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="oldmanName" label="客户姓名:">
              <span class="height40">
                {{ manualOperationRecharge.oldmanName }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="userPhone" label="联系方式:" :disabled="true">
              <span class="height40">
                {{ manualOperationRecharge.userPhone }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="serviceSecondLevelName" label="服务项目:">
              <span class="height40">
                {{ manualOperationRecharge.serviceSecondLevelName }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="price" label="支付金额:" :disabled="true">
              <span class="height40">
                {{ manualOperationRecharge.price }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="method" label="支付方式:" :disabled="true">
              <el-select
                v-model="manualOperationRecharge.method"
                filterable
                placeholder="请选择"
                size="small"
                clearable
              >
                <el-option
                  v-for="item in manualOperationRechargeMethodOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <div id="qrCode" ref="qrCodeDiv" class="modeOfPaymentImg"></div> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          :size="size"
          @click="
            manualOperationRechargeDialogVisible = false;
            resetManualOperationRechargeForm('manualOperationRechargeForm');
          "
          >取 消</el-button
        >
        <el-button
          :size="size"
          type="primary"
          @click="
            submitManualOperationRechargeForm('manualOperationRechargeForm')
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 扫码支付 -->
    <el-dialog
      :title="modeOfPaymentTitle + '扫码支付'"
      width="30%"
      :visible.sync="modeOfPaymentDialogVisible"
      center
      top="15vh"
      :close-on-click-modal="false"
    >
      <el-form
        v-loading="modeOfPaymentLoading"
        :element-loading-text="loadingText"
      >
        <el-form-item>
          <!-- <img :src="modeOfPaymentImg" alt="" class="modeOfPaymentImg" /> -->
          <div
            v-loading="qrCodeLoading"
            element-loading-text="拼命加载中"
            id="qrCode"
            ref="qrCodeDiv"
            class="modeOfPaymentImg"
          ></div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :size="size" @click="callPay">取消支付</el-button>
        <el-button :size="size" type="primary" @click="accomplishPay"
          >支付完成</el-button
        >
      </span>
    </el-dialog>


  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import service_loc from "@/assets/map/service_loc.png";
import oldman_loc from "@/assets/map/oldman_marker.png";
import { baseURL } from "@/utils/request.js";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      isTimeCorrect: false,
      defaultOldManList: [],
      size: "medium",
      userId: 1030,
      orderSourceList: [
        { label: "手机下单", value: 1 },
        { label: "平台下单", value: 2 },
        { label: "政府下单", value: 3 },
        { label: "平台导入", value: 4 },
      ], //工单的来源
      secondServerList: [], //服务大类及服务小类
      storeList: [], //商家列表
      goodList: [],
      
      orderChoose: [
        { label: "已接单", value: 1 },
        { label: "服务中", value: 4 },
        { label: "已签退", value: 5 },
        { label: "已完成", value: 8 },
        { label: "已取消", value: 7 },
      ], //订单的状态
      orderStatusList: [
        { label: "待接单", value: 0 },
        { label: "已接单", value: 1 },
        { label: "已签到", value: 2 },
        { label: "开始服务中", value: 3 },
        { label: "服务中", value: 4 },
        { label: "已签退", value: 5 },
        { label: "已撤单", value: 6 },
        { label: "服务已取消", value: 7 },
        { label: "已完成", value: 8 },
      ], //订单的状态
      filters: {
        oldmanName:'',
        userNameGet:'',
        orderSource: null,
        orderStatus: null,
        //new Date().setHours(0, 0, 0, 0)
        timevalue: '',
      },
      //新增订单的dialog模态框配置
      addOrderDialogVisible: false,
      dataForm: {
        oldmanId: "",
        oldmanName: "",
        oldIdCard: "",
        date1: "",
        data2: "",
        community:"",
        oldPhone: "",
        relationshipa: "",
        serviceAddress: "",
        orderSource: 2,
        service: "",
        time: "",
        remark: "",
        oldAddressBdGps: "",
        serviceOrderItemList: [],
        settlementAmount: 0,
      },
      pickerOptions2: {
        shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '本月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(1)
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          }],
        disabledDate: (time) => {
          return time.getTime() > (Date.now() + 60*1000*60*24);
        },
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      }, // 禁止选择本日前日期
      useOrderInfo: {
        userIdPut: "",
        userNamePut: "",
        userPhone: "",
      },
      orderInfo: {
        community:"",
      },
      dataFormRules: {
        oldmanName: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
          },
        ],
        serviceAddress: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
          },
        ],
        service: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
          },
        ],
        remark: [{ min: 0, max: 50, message: "长度在 0到 50 个的字符" }],
      },
      //选择商品的dialog模态框
      dialogFormVisible: false,

      //tree树默认显示的
      data: [],
      projectItem:[],
      defaultProps: {
        children: "children",
        label: "label",
      },
      orderDetailVisible:false,
      orderDetail:{},
      //手动派单
      manualDeliveryDialogVisible: false,
      servicePersonnelList: [], //服务人员的
      manualDataForm: {
        id: "",
        oldmanName: "",
        oldPhone: "",
        serviceAddress: "",
        service: "",
        userIdGet: "",
        userNameGet: "",
        remark: "",
      },
      //手动派单的校验
      manualDataFormRules: {
        userIdGet: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
          },
        ],
        remark: [{ min: 0, max: 50, message: "长度在 0到 50 个的字符" }],
      },
      goodsItemText: "", //购买商品的回显数据
      goodsItemPrice: 0, //购买商品的价格回显数据
      tableData: [],
      multipleSelection: [],
      expands: [], //表格展开的id集合
      /* 分页的 */
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      total: 0, //数据的总数,
      groupId: "",
      tree: {},
      areaList:[],
      merchantList: [], //商家的集合
      //服务地址地图配置
      keyword: "", //模糊搜索
      oldmanId: "", //老人的id,用于请求数据获取老人的百度经纬度
      oldmanlng: "", //经度
      oldmanlat: "", //纬度
      postionMap: { lng: 0, lat: 0 }, //点击获取经纬度
      postionHuiXian: { lng: 0, lat: 0 }, //回显的经纬度坐标
      add: { jd: "", wd: "", siteName: "", site: "" }, //添加的mark
      showMark: false, //Mark点显示隐藏
      showMarkHuiXian: false, //修改回显mark点的提示
      dialogFormVisibleSafe: false, //选择老人的家庭住址的模态框
      center: { lng: 0, lat: 0 }, //中心点
      zoom: 3, //缩放比例
      mapType: "", //地图类型，不填就是默认样式
      //设置自定义主题
      mapStyle: {
        styleJson: [
          {
            featureType: "all",
            elementType: "geometry",
            stylers: {
              hue: "#007fff",
              saturation: 89,
            },
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: {
              color: "#ffffff",
            },
          },
        ],
      },
      BMap: "",
      map: "",
      // 定位地图
      iconLocation: { url: service_loc, size: { width: 48, height: 48 } },
      iconWatch: { url: oldman_loc, size: { width: 48, height: 48 } },
      markers: [], //marker点集合
      center: { lng: 0, lat: 0 }, //中心点
      zoom: 3, //缩放比例
      mapType: "", //地图类型，不填就是默认样式
      //设置自定义主题
      mapStyle: {
        styleJson: [
          {
            featureType: "all",
            elementType: "geometry",
            stylers: {
              hue: "#007fff",
              saturation: 89,
            },
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: {
              color: "#ffffff",
            },
          },
        ],
      },
      /* 手动充值 */
      // 弹窗状态
      manualOperationRechargeDialogVisible: false,
      // 表单数据源
      manualOperationRecharge: {
        name: "",
        investBalance: "",
        phone: "",
        giftBalance: "",
        date: new Date().toLocaleDateString(),
        remainingSum: "",
        levelName: "",
        method: "",
      },
      // 姓名选择器数据源
      manualOperationRechargeNameOptions: [],
      // 充值金额选择器数据源
      manualOperationRechargeinvestBalanceOptions: [],
      // 充值方式选择器数据源
      manualOperationRechargeMethodOptions: [
        {
          value: "1",
          label: "支付宝支付",
        },
        {
          value: "2",
          label: "微信支付",
        },
        {
          value: "3",
          label: "现金支付",
        },
      ],
      // 手动充值表单校验
      manualOperationRechargeRules: {
        method: [
          { required: true, message: "请选择充值方式", trigger: "blur" },
        ],
      },
      // 支付方式
      modeOfPaymentTitle: "",
      modeOfPaymentImg: "",
      modeOfPaymentDialogVisible: false,
      modeOfPaymentLoading: false,
      loadingText: "交易进行中...",
      qrCodeLoading: true,
      flag: true,
    };
  },
  methods: {
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 500; text-align: center;font-size: 14px;background-color: #efefef;";
      }
    },
    getCostTypeStr(type){
      if(type == 0){
        return "元/次"
      }else if(type == 1){
        return "元/小时"
      }else if(type == 2){
        return "元/分钟"
      }else if(type == 2){
        return "元/天"
      }else{
        return "元/月"
      }
    },
    formatType: function (row) {
      if(row.paymentMethod == 0){
        return "元/次"
      }else if(row.paymentMethod == 1){
        return "元/小时"
      }else if(row.paymentMethod == 2){
        return "元/分钟"
      }else if(row.paymentMethod == 2){
        return "元/天"
      }else{
        return "元/月"
      }
    },
    formatSource(row){
      //工单来源 1-用户app下单 2-平台下单 3-服务人员下单 4-其他平台下单
      if(row.orderSource == 1){
        return "用户下单"
      }else if(row.orderSource == 2){
        return "平台下单"
      }else if(row.orderSource == 3){
        return "服务人员下单"
      }else if(row.orderSource == 4){
        return "其他平台下单"
      }else{
        return "用户下单"
      }
    },
    formatStatus2(status2){
      let status = "-";
      this.orderStatusList.forEach(item=>{
        if(item.value == status2){
            status =  item.label;
        }
      })
      return status
    },
    formatStatus(row){
      let status = "-";
      this.orderStatusList.forEach(item=>{
        if(item.value == row.orderStatus){
            status =  item.label;
        }
      })
      return status
    },
    showmap(detail){
      const _this = this
      AMapLoader.load({
        key: 'bb369d6617c417b4826cee55ac7ad116',
        version: '2.0',
        plugins: []
      }).then((AMap) => {
        //服务人员定位
        let serviceLoc = [];
        let oldLoc = [];
        if(detail.signAddressGps!=null && detail.signAddressGps.length > 5){
          serviceLoc = detail.signAddressGps.split(",")
          serviceLoc[0] = Number(serviceLoc[0]);
          serviceLoc[1] = Number(serviceLoc[1]);
        }

        if(detail.gpsAddress!=null && detail.gpsAddress.length > 5){
          oldLoc = detail.gpsAddress.split(",")
          oldLoc[0] = Number(oldLoc[0]);
          oldLoc[1] = Number(oldLoc[1]);
        }
        console.log(serviceLoc)
        console.log(oldLoc)

        const map = new AMap.Map('container', {
            zoom: 15, // 初始化地图级别
            zooms: [5, 30], // 地图缩放范围
            // 可以设置初始化当前位置
            center: serviceLoc
        })

        var marker2 = new AMap.Marker({
            position: serviceLoc,
            icon: new AMap.Icon({            
	                image: oldman_loc,
	                size: new AMap.Size(32, 32),  //图标所处区域大小
	                imageSize: new AMap.Size(32,32) //图标大小
	          }),
            offset: new AMap.Pixel(-16, -32)
        });
        marker2.setMap(map);
        map.add(marker2)
        var marker = new AMap.Marker({
            position: oldLoc,
            icon: new AMap.Icon({            
	                image: service_loc,
	                size: new AMap.Size(38, 38),  //图标所处区域大小
	                imageSize: new AMap.Size(38,38) //图标大小
	          }),
            offset: new AMap.Pixel(-19, -38)
        });
        marker.setMap(map);
        map.add(marker)
      })
      this.dialogFormVisibleSafe = true;
    },
    //处理选择时间不能在当前时间之前
    getTimeAccuracy() {
      const time = new Date();
      let selectDay = this.dataForm.date1.split("-");
      let today = time.toLocaleDateString().split("/");
      const now = time.getTime();
      let selectTime = Date.parse(
        time.toLocaleDateString() + " " + this.dataForm.date2
      );
      let isToday = selectDay.every((val, index) => {
        return Number(val) == Number(today[index]);
      });
      if (isToday && now > selectTime) {
        this.isTimeCorrect = false;
      } else {
        this.isTimeCorrect = true;
      }
    },
    BlurNumber(e) {
      let boolean = new RegExp("^[0-9][0-9]*$").test(e.target.value);
      if (!boolean) {
        e.target.value = 0;
      }
    },
    /* 
      查询按钮查询
    */
    onSubmit() {
      this.queryList((this.pageNum = 1), (this.pageSize = 10));
    },

    /* 
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.queryList((this.pageNum = 1), (this.pageSize = 10));
      }
    },

    //新增工单
    handleAdd() {
      this.addOrderDialogVisible = true;
      this.dataForm = {
        oldmanId: "",
        oldmanName: "",
        oldIdCard: "",
        oldPhone: "",
        relationshipa: "",
        serviceAddress: "",
        date1: "",
        date2: "",
        orderSource: 2,
        service: "",
        time: "",
        remark: "",
        oldAddressBdGps: "",
        serviceOrderItemList: [],
        settlementAmount: 0,
      };
      this.storeList = [];
      this.goodList = [];
      this.multipleSelection = [];
      (this.orderInfo = {}),
        this.$nextTick(() => {
          if (this.$refs.dataForm != undefined) {
            this.$refs.dataForm.resetFields();
          }
        });
      this.querySericeType();
    },

    /* 
      新增订单提交数据
    */
    submitAddOrderForm() {
    
      if (
        this.dataForm.projectId == null ||
        this.dataForm.projectId == ""
      ) {
        this.$message({ message: "请选择服务项目", type: "error" });
        return;
      }
      if (this.dataForm.oldmanId == null || this.dataForm.oldmanId == "") {
        this.$message({ message: "请选择老人", type: "error" });
        return;
      }
      this.dataForm.serviceReservationTime =  this.dataForm.date1 + " " +  this.dataForm.date2;
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          let params = new Object();
          params.orderSource = 2;
          params.oldmanId = Number(this.dataForm.oldmanId);
          params.serviceAddress = this.dataForm.detailedAddress || '未知';
          params.remark = this.dataForm.remark;
          params.groupId = this.groupId;
          params.projectId =  Number(this.dataForm.projectId);
          params.serviceReservationTime =  this.dataForm.serviceReservationTime;
          this.$postJson("omc/serviceOrder/addItemOrder", params).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.addOrderDialogVisible = false;
            this.queryList();
          });
        }
      });
    },

    /* 
      模糊搜索老人
    */
    querySearchAsync(queryString, cb) {
      //根据 queryString 搜索
      var param = {
        oldName:queryString,
        pageNo:"1",
        pageSize:"20",
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        this.oldmanList = res.result.list;
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          this.defaultOldManList = list;
          cb(list);
          this.deleteOldmanInfo();
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.dataForm.oldmanName = "";
            this.deleteOldmanInfo();
          }, 100);
        }
      });
    },

    /* 
      选择老人
    */
    handleOlderSelect(item) {
      this.dataForm.oldmanId = item.oldmanId;
      this.dataForm.serviceAddress = item.oldAddress;
      this.dataForm.detailedAddress = item.oldAddress;
      this.dataForm.oldAddressBdGps = item.oldAddressBdGps;
      this.dataForm.community = item.oldAddressBdGps;
      this.orderInfo.oldIdCard = item.oldIdCard;
      this.orderInfo.oldPhone = item.oldPhone;
      this.orderInfo.community = item.cardAddress;

    },
    handleCatalogChange(value){
      this.$postJson('omc/serviceProject/queryProjectList', 
      { pageNum:this.pageNum ,pageSize: 99, isUse:1,catalogId:value[1] })
      .then(res=>{
        res.result.list.forEach(item=>{
          item.name = item.name + " "+item.unitPrice + this.getCostTypeStr(item.paymentMethod)
        })
        this.projectItem = res.result.list;
      })
    },
    /* 
      清空回显老人信息的数据    
    */
    deleteOldmanInfo() {

    },
    /* 
      家庭地址的聚焦选择地址
    */
    focusServiceAddress() {
      // this.dialogFormVisibleSafe = true;
    },

    //点击地图里面的input搜素框输入搜索，获取所有搜索的地址的数组 []
    markersset(e) {
      console.log(e);
      //输入家庭住址时，让搜索的结果显示
      document.getElementById("bm-local-search").style.display = "block";
    },

    //点击搜索的结果，获取点击获取的地址
    infohtmlset(e) {
      console;
      //先置空
      this.dataForm.serviceAddress = "";
      console.log(e);
      console.log(e.address);
      console.log(e.point);
      //把搜索选取的地址赋给外层dialog 家庭地址的input框
      this.dataForm.serviceAddress = e.address;
      this.dataForm.detailedAddress = e.address;
      this.dataForm.oldAddressBdGps = `${e.point.lng},${e.point.lat}`;
      //当选取了地址后，让其隐藏
      document.getElementById("bm-local-search").style.display = "none";
    },

    //点击地图dialog叉号关闭 重置
    closeMap() {
      console.log("aaa");
      this.postionMap.lng = "";
      this.postionMap.lat = "";
      this.postionHuiXian.lng = "";
      this.postionHuiXian.lat = "";
      this.show = false;
      this.keyword = ""; //搜索框置空
      //关闭dialog ,input框自动聚焦 比较友好
      let inputelementAdd = document.getElementById("oldAddressAdd");
      if (inputelementAdd != null) {
        //判断一下 因为编辑时打开地图时此值不存在的
        inputelementAdd.focus();
      }
      let inputelement = document.getElementById("oldAddress");
      if (inputelement != null) {
        //判断一下 因为新增时打开地图时此值不存在的
        inputelement.focus();
      }
    },

    //点击地图，记住地图选取的地址，清除上次点击的位置
    sureMap() {
      this.dialogFormVisibleSafe = false;
      this.postionMap.lng = "";
      this.postionMap.lat = "";
      this.postionHuiXian.lng = "";
      this.postionHuiXian.lat = "";
      this.show = false;
      this.keyword = ""; //搜索框置空
      //关闭dialog,input框自动聚焦 比较友好
      let inputelementAdd = document.getElementById("oldAddressAdd");
      if (inputelementAdd != null) {
        //判断一下 因为编辑时打开地图时此值不存在的
        inputelementAdd.focus();
      }
      let inputelement = document.getElementById("oldAddress");
      if (inputelement != null) {
        //判断一下 因为新增时打开地图此值不存在的
        inputelement.focus();
      }
    },

    //生成地图实例
    handler({ BMap, map }) {
      //(BMap, map)地图组件渲染完毕时触发，返回一个百度地图的核心类和地图实例。百度地图组件是异步加载，
      //请不要尝试在组件的生命周期中访问 BMap 核心类和 map 实例，如有需要，请在所需组件的 ready 事件回调函数的参数中获取。
      console.log(BMap, map);
      //武汉的经纬度 zoom为地图显示的比例
      this.center.lng = 114.31667;
      this.center.lat = 30.51667;
      this.zoom = 15;
      //  //获取定位的数据
      this.center.lng = this.center.longitude;
      this.center.lat = this.center.latitude;
      window.map = map;
      // 赋值，方便调用，本节被用到
      this.BMap = BMap;
      this.map = map;
    },

    //点击获取mark
    getPoint(e) {
      //点击地图获取一些信息，
      console.log(e);
      (this.postionHuiXian.lng = ""), //把会显得点去掉
        (this.postionHuiXian.lat = "");
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();
      // this.center.lng=e.point.lng;
      // this.center.lat=e.point.lat;
      console.log(e.point);
      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.add.site = rs.address;
        this.dataForm.serviceAddress = rs.address;
        // this.keyword = rs.address;
        this.dataForm.oldAddressBdGps = `${e.point.lng},${e.point.lat}`;
        this.dataForm.longitude = e.point.lng;
        this.dataForm.latitude = e.point.lat;
        this.dataForm.detailedAddress = rs.address;
        //地址描述(string)=
        console.log(rs.address); //这里打印可以看到里面的详细地址信息，可以根据需求选择想要的
        console.log(rs.addressComponents); //结构化的地址描述(object)
        console.log(rs.addressComponents.province); //省
        console.log(rs.addressComponents.city); //城市
        console.log(rs.addressComponents.district); //区县
        console.log(rs.addressComponents.street); //街道
        console.log(rs.addressComponents.streetNumber); //门牌号
        console.log(rs.surroundingPois); //附近的POI点(array)
        console.log(rs.business); //商圈字段，代表此点所属的商圈(string)
      });
      console.log(e.point); //打印markpoint
    },

    //点击生成mark点的提示关闭
    infoWindowClose() {
      this.show = false;
    },

    //提示打开
    infoWindowOpen() {
      //这里有个问题纠结了很久，百度的信息窗口默认有个点击其他地方就消失的事件，我没有找到
      //并且信息窗口点击一次显示，一次消失
      //于是我加了一个100毫秒的定时器，保证每次点击地图都可以展示信息窗口
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    //导出
    downLoad() {
      let params = new Object();
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      params.oldmanName = this.filters.oldmanName;
      params.userNameGet = this.filters.userNameGet;
      params.statusList = [];
      if(this.filters.orderStatus!=null && this.filters.orderStatus!==''){
        if(this.filters.orderStatus == 1){
          params.statusList=[1]
        }else if(this.filters.orderStatus == 4){
          params.statusList=[2,3,4]
        }else if(this.filters.orderStatus == 5){
          params.statusList=[5]
        }else if(this.filters.orderStatus == 8){
          params.statusList=[8]
        }
        // params.statusList = [this.filters.orderStatus];
      }else{
        params.statusList = [0,1,2,3,4,5,6,8];
      }
      if(this.filters.timevalue){
          params['startTime'] = this.filters.timevalue[0] + " 00:00:00";
          params['endTime'] = this.filters.timevalue[1] +" 23:59:59";
      }
      if(this.filters.communityList!=null && this.filters.communityList.length>0){
        params.communityList = this.filters.communityList;
      }
      params.groupId = this.groupId;
  const queryParams = Object.keys(params)
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
  .join('&');
  window.location.href =
          baseURL +
          `omc/api/downOrderNewList?${queryParams}`;
    },
    /* 
      服务项目聚焦选择商品
    */
    focusServiceItem() {
      this.dialogFormVisible = true;
      // this.queryMerchant();
    },
    getNum(value) {
      console.log(value);
      console.log(this.goodList);
    },
    /* 
      查询商家和服务类别
    */
    queryMerchant() {
      let params = new Object();
      this.merchantList = [];
      this.data = [];
      this.$postJson("uac/merchant/select", params).then((res) => {
        console.log(res, "查询商家和服务类别信息");
        if (res.code == 200) {
          if (res.result != null || res.result.list.length > 0) {
            this.merchantList = [];
            res.result.list.forEach((item) => {
              let dataObj = {};
              dataObj.id = item.id;
              dataObj.label = {
                labelOne: item.merchantName,
                labelTwo: "",
                labelThree: "",
                show: false,
                number: 0,
                type: "first",
              };
              dataObj.children = [];
              if (item.firstLevelIds != null && item.firstLevelIds.length > 0) {
                item.firstLevelIds.forEach((temp) => {
                  let secDataObj = {};
                  secDataObj.merchantId = item.id;
                  secDataObj.id = temp;
                  secDataObj.label = {
                    labelOne: "",
                    labelTwo: "",
                    labelThree: "",
                    show: false,
                    number: 0,
                    type: "second",
                  };
                  secDataObj.children = [];
                  dataObj.children.push(secDataObj);
                });
              }
              this.merchantList.push(dataObj); //获取商家的数据
            });
            console.log(this.merchantList, "oooooooooooo");
            this.querySericeType();
          }
        }
      });
    },
    /* 
      节点展开
    */
    nodeExpand(data, node, vuecomponent) {
      console.log(data, node, vuecomponent);
      //通过type=='first' 取到商家id和商家名称
      if (data.label.type == "first") {
        this.dataForm.merchantId = data.id;
        this.dataForm.merchantName = data.label.labelOne;
      }
    },

    /* 
      点击tree菜单
    */
    handleNodeClick(data, node, vuecomponent) {
      console.log(data, node, vuecomponent);
    },

    /* 
      节点checkbox点击
    */
    checkClick(checkedNodes, checkedKeys) {},

    /* 
      input值变化的时候调用时间
    */
    changeValue(e) {
      console.log(e);
    },
    selectGoods() {
      var serviceOrderItemList = [];
      this.dataForm.service = "";
      this.dataForm.settlementAmount = 0;
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (
          this.multipleSelection[i].number != "" &&
          this.multipleSelection[i].number != undefined &&
          this.multipleSelection[i].number != 0
        ) {
          serviceOrderItemList.push({
            id: this.multipleSelection[i].id,
            number: this.multipleSelection[i].number,
          });
          this.dataForm.settlementAmount +=
            this.multipleSelection[i].number *
            this.multipleSelection[i].unitPrice *
            1;
          this.dataForm.service += `${this.multipleSelection[i].merchandiseName}*${this.multipleSelection[i].number}*${this.multipleSelection[i].unitPrice}元；`;
        }
      }
      this.dataForm.serviceOrderItemList = serviceOrderItemList;
      this.dialogFormVisible = false;
      console.log(this.dataForm);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleFinishMnually(row) {
      this.$confirm("是否确认完成服务订单?", "完成订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: "true",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          //   this.$postJson(`omc/serviceOrder/pay/${row.id}`).then(res => {
          // if (res.code == 200) {
          this.$postJson(`omc/serviceOrder/complete/${row.id}`).then((res) => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.queryList();
          });
          // } else {
          //   this.$message({ message: res.message, type: "error" });
          // }
          //   });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleDetail(row1){
      // /omc/serviceOrder/orderDetail/
      this.$postJson(`omc/serviceOrder/orderDetail/${row1.id}`).then(res=>{
        if(res.code == 200){
          let row = res.result;
          row.signAddress = "";
          row.signAddressGps = "";
          if(row.oldmanCard.indexOf("9999")!=-1){
            row.oldmanCard = "-";
          }
          row.imgUrls1 = [];
          row.imgUrls2 = [];
          row.imgUrls3 = [];
          row.omcServiceOrderContents.forEach(item=>{
            if(item.type == 2){
              if(item.serviceAddress!=null && item.serviceAddress.length>2){
                row.signAddress = item.serviceAddress;
              }
              if(item.serviceGps!=null && item.serviceGps.length>2){
                row.signAddressGps = item.serviceGps;
              }
            }else if(item.type == 3 && item.imgUrls.length>5){
              row.imgUrls1 = item.imgUrls.split(",");
            }else if(item.type == 4 && item.imgUrls.length>5){
              row.imgUrls2 = item.imgUrls.split(",");
            }else if(item.type == 9 && item.imgUrls.length>5){
              row.imgUrls3 = item.imgUrls.split(",");
            }else if(item.type == 4){
              if(item.serviceAddress!=null && item.serviceAddress.length>2){
                row.signAddress = item.serviceAddress;
              }
              if(item.serviceGps!=null && item.serviceGps.length>2){
                row.signAddressGps = item.serviceGps;
              }
            }
          })
          this.orderDetail = row;
          this.orderDetailVisible = true;
          console.log(this.orderDetail)
          console.log(this.orderDetail)
        }else{
          this.$message({ message: res.message, type: "error" });
        }
      })

    },
    /* 
      手动派单弹出dialog模态框
    */
    handleDistributeMnually(row) {
      console.log(row);
      this.manualDeliveryDialogVisible = true;
      this.manualDataForm.id = row.id;
      this.manualDataForm.oldmanName = row.oldmanName;
      this.manualDataForm.oldPhone = row.oldmanPhone;
      this.manualDataForm.serviceAddress = row.serviceAddress;
      this.manualDataForm.serviceContent = row.serviceContent;
      this.manualDataForm.total = row.total;
      this.queryServiceList();
    },

    /* 
      手动派单提交数据
    */
    submitManualDataForm() {
      this.$refs.manualDataForm.validate((valid) => {
        if (valid) {
          let params = new Object();
          params.id = this.manualDataForm.id;
          params.userIdGet = this.manualDataForm.userIdGet;
          params.userNameGet = this.manualDataForm.userNameGet;
          params.userPhoneGet = this.manualDataForm.userPhoneGet;
          params.remark = this.manualDataForm.remark;
          this.$postJson("omc/serviceOrder/assign", params).then((res) => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.manualDeliveryDialogVisible = false;
            this.queryList();
          });
        }
      });
    },

    /* 
      选择服务人员
    */
    changeServicePeople(val) {
      this.servicePersonnelList.forEach((item) => {
        if (val == item.userId) {
          this.manualDataForm.userNameGet = item.userName;
          this.manualDataForm.userPhoneGet = item.mobileNo;
        }
      });
    },

    /* 
      取消派单
    */
    handleCancel(row) {
      console.log(row);
      this.$confirm("是否确认取消服务订单?", "取消订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: "true",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          this.$postJson(`omc/serviceOrder/retreat/${row.id}`).then((res) => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.queryList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    /* 
      获取表格展开的id
    */
    getRowKeys: function (row) {
      return row.id;
    },

    /* 
      展开和关闭表格的事件
    */
    expandChange(row, expandedRows) {
      console.log(row, expandedRows, "defiiefigi");
      // this.queryMerchantDetail(row.id);
    },

    /* 
      分页查询列表
    */
    queryList() {
      let params = new Object();
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      // params.orderNo = this.filters.orderNo ||'';
      params.oldmanName = this.filters.oldmanName;
      params.userNameGet = this.filters.userNameGet;
      // params.specialNameList = ['特困服务','低保服务','市场服务','失能人员居家照料'];
      params.orderSource = this.filters.orderSource;
      params.statusList = [];
      if(this.filters.orderStatus!=null && this.filters.orderStatus!==''){
        console.log(this.filters.orderStatus);
        if(this.filters.orderStatus == 1){
          params.statusList=[1]
        }else if(this.filters.orderStatus == 4){
          params.statusList=[2,3,4]
        }else if(this.filters.orderStatus == 5){
          params.statusList=[5]
        }else if(this.filters.orderStatus == 8){
          params.statusList=[8]
        }else if(this.filters.orderStatus == 7){
          params.statusList=[7]
        }
        // params.statusList = [this.filters.orderStatus];
      }else{
        params.statusList = [0,1,2,3,4,5,6,8];
      }
      if(this.filters.timevalue){
          params['startTime'] = this.filters.timevalue[0] + " 00:00:00";
          params['endTime'] = this.filters.timevalue[1] +" 23:59:59";
      }
      if(this.filters.communityList!=null && this.filters.communityList.length>0){
        params.communityList = this.filters.communityList;
      }
      params.groupId = this.groupId;
      this.$postJson("omc/serviceOrder/orderList", params).then((res) => {
        this.tableData = [];
        if (res.code == 200) {
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.total = res.result.total * 1;
            this.tableData = res.result.list
          } else {
            this.tableData = [];
            this.total = 0;
          }
        }
      });
    },

    /* 
      获取商品详情
    */
    queryMerchantDetail(orderId) {
      this.$postJson(`omc/serviceOrder/orderDetail/${orderId}`).then((res) => {
        if (res.result.itemList) {
          this.goodsItemText = "";
          this.goodsItemPrice = 0;
          res.result.itemList.forEach((item) => {
            this.goodsItemText += `${item.name}*${item.number}*${item.price}元；`;
            this.goodsItemPrice += item.price * item.number * 1;
          });
          this.manualDataForm.service = this.goodsItemText;
        }
      });
    },

    /* 
      获取登录用户的信息
    */
    getUserData() {
      this.$postForm("omc/group/getUserLongDetail", {}).then((response) => {
        console.log(response, "response");
        this.useOrderInfo.userIdPut = response.result.userId;
        this.useOrderInfo.userNamePut = response.result.userName;
        this.useOrderInfo.userPhone = response.result.phone;
      });
    },

    /* 
      查询服务类别
    */
    querySericeType() {
      let params = new Object();
      params.groupId = this.groupId;
      this.$postJson("omc/serviceProject/listServiceCatalog", { pageNum:1 ,pageSize: 99, isUse:1 }).then((res) => {
        let treeList = [];
          res.result.forEach(item => {
            let children = [];
            if(item.serviceProjectCatalogList!=null && item.serviceProjectCatalogList.length>0){
              item.serviceProjectCatalogList.forEach(item2=>{
                children.push({
                  value: item2.id,
                  label: item2.name,
                  id: item2.id
                })
              })
            }
            treeList.push({
              id: item.id,
              label: item.name,
              value: item.id,
              children: children
            })
        })
        this.secondServerList = treeList;
      });


    },

    /* 
      查询商品
    */
    queryCommodity() {
      let params = new Object();
      this.$postJson("omc/merchandis/selectmer", params).then((res) => {
        console.log(res, "查询商品");
        this.merchantList.forEach((item) => {
          console.log(item, "item");
          item.children.forEach((temp, index) => {
            if (res.result.list.length > 0) {
              res.result.list.forEach((ele) => {
                if (item.id == ele.merchantId && temp.id == ele.firstLevelId) {
                  let obj = {};
                  obj.id = ele.id;
                  obj.label = {
                    labelOne: ele.merchandiseName,
                    labelTwo: ele.unitPrice,
                    labelThree: "",
                    show: true,
                    number: 0,
                    type: "third",
                  };
                  obj.children = [];
                  temp.children.push(obj);
                }
              });
            } else {
              item.children.splice(index, 1);
            }
          });
        });
        console.log(this.merchantList, "经过第三次处理之后的");
        var allMearchantList = []; //用来存放商家
        var firstLevelIdList = []; //用来存放有商品的服务类别
        this.merchantList.forEach((item) => {
          let dataObj = {};
          dataObj.id = item.id;
          dataObj.label = {
            labelOne: item.label.labelOne,
            labelTwo: "",
            labelThree: "",
            show: false,
            number: 0,
            type: "first",
          };
          dataObj.children = [];
          allMearchantList.push(dataObj); //将商家添加进来
          item.children.forEach((temp, i) => {
            //判断该服务类别下面是否有商品  大于0就是有商品  将其添加进另外一个数组中
            if (temp.children.length > 0) {
              firstLevelIdList.push(temp); //把服务类别下面有商品的数据给挑选出来
            }
          });
        });
        console.log(allMearchantList, firstLevelIdList, "firstLevelIdList");
        allMearchantList.forEach((item) => {
          firstLevelIdList.forEach((temp) => {
            if (item.id == temp.merchantId) {
              item.children.push(temp); //将服务类别和商品添加进来
            }
          });
        });
        var secondAllMearchantList = []; //最后处理得到的数据源
        allMearchantList.forEach((item) => {
          if (item.children.length > 0) {
            //去除商家下面商品类别为空的
            secondAllMearchantList.push(item);
          }
        });
        console.log(
          allMearchantList,
          "allMearchantList",
          secondAllMearchantList
        );
        this.data = secondAllMearchantList; //将处理之后的数据赋值给tree的数据源
      });
    },

    /* 
      获取服务人员
    */
    queryServiceList() {
      let params = new Object();
      params.pageNum = 1;
      params.pageSize = 99;
      this.$postJson("uac/staff/selectStaffByNotSpecoalist", params).then(
        (res) => {
          console.log(res, "查询服务人员");
          if (res.code == 200) {
            this.servicePersonnelList = [];
            res.result.list.forEach((item) => {
              this.servicePersonnelList.push(item);
            });
          }
        }
      );
    },
    indexMethod(index){
      return (Number(this.pageNum-1) * Number(this.pageSize))+ index +1;
    },
    /* 
      初始页currentPage、初始每页数据数pagesize和数据data
    */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.pageSize = val;
      this.queryList(); //刷新列表的数据
    },
    /* 
      当前页变化
    */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.queryList(); //刷新列表的数据
    },

    /* 
      表格头部的样式
    */
    headerStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #CCCCCC;";
      }
    },

    // 选中商品
    goodSelect(selectedGoods) {
      if (selectedGoods.length !== 0) {
        selectedGoods.forEach((item) => {
          item.number || (item.number = 1);
        });
      }
    },

    // 清空老人姓名--新增工单
    deleteOldManName() {
      this.dataForm = {
        oldmanId: "",
        oldmanName: "",
        oldIdCard: "",
        date1: "",
        data2: "",
        oldPhone: "",
        relationshipa: "",
        serviceAddress: "",
        orderSource: null,
        service: "",
        time: "",
        remark: "",
        oldAddressBdGps: "",
        serviceOrderItemList: [],
        settlementAmount: 0,
      };
      this.deleteOldmanInfo();
    },

    /* 
      确认订单
    */
    handlesure(row) {
      this.$confirm("是否确认订单?", "确认订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: "true",
        type: "warning",
        closeOnClickModal: false
      })
        .then(() => {
          this.$postJson(`omc/serviceOrder/merchantConfirm/${row.id}`).then(res => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.queryList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 手动充值
    // 手动充值按钮
    handleClean(row) {
      console.log(row);
      console.log(row.id, "id");
      console.log(row.orderNo, "orderNo");
      console.log(row.oldmanName, "oldmanName");
      console.log(row.userPhone, "userPhone");
      console.log(row.serviceSecondLevelName, "serviceSecondLevelName");
      console.log(row.statusText, "statusText");
      this.manualOperationRecharge = {
        id: row.id,
        orderNo: row.orderNo,
        oldmanName: row.oldmanName,
        userPhone: row.userPhone,
        serviceSecondLevelName: row.serviceSecondLevelName,
        statusText: row.statusText,
      };
      this.curOrderId = row.id;
      // 获取订单详情
      this.$postJson(`omc/serviceOrder/detail/${row.id}`).then((res) => {
        if (res.result.itemList) {
          this.manualOperationRecharge.name = "";
          this.manualOperationRecharge.price = 0;
          res.result.itemList.forEach((item) => {
            this.manualOperationRecharge.name = item.name;
            this.manualOperationRecharge.price = item.price;
          });
          this.manualOperationRechargeDialogVisible = true;
          this.manualDataForm.service = this.goodsItemText;
        }
      });
    },
    // 生成订单号
    getOrderNo(params) {
      console.log(params.orderNo, "paramsorderNo");
      // let para = {
      //   investAmount: params.investAmount,
      // };
      let id = this.curOrderId;
      this.$postJson(`omc/serviceOrder/pay/${id}`).then((res) => {
        if (res.code == 200) {
          let pnlinePayParams = {};
          if (this.manualOperationRecharge.method == "1") {
            pnlinePayParams.payType = 22;
            this.modeOfPaymentTitle = "支付宝";
          } else if (this.manualOperationRecharge.method == "2") {
            pnlinePayParams.payType = 41;
            this.modeOfPaymentTitle = "微信";
          } else if (this.manualOperationRecharge.method == "4") {
            pnlinePayParams.payType = 30;
            this.modeOfPaymentTitle = "银联";
          }
          pnlinePayParams.orderNo = res.result.orderNo;
          pnlinePayParams.totalAmount = this.manualOperationRecharge.price;
          pnlinePayParams.workNo = params.orderNo;
          setTimeout(() => {
            this.manualOperationRechargeDialogVisible = false;
          }, 200);
          this.queryList();
          //在线支付
          // if (pnlinePayParams) {
          //   this.goOnlinePay(pnlinePayParams);
          // }
        }
      });
    },
    // 获取在线支付二维码
    goOnlinePay(params) {
      console.log(params, "params");
      this.$postMyForm("omc/api/onlinePay2", params).then((res) => {
        // this.$postForm(`omc/api/onlinePay`, params).then((res) => {
        // this.$postJson(`omc/api/onlinePay`, params).then((res) => {
        // this.$postMyForm(`opc/api/onlinePay`, params).then((res) => {
        if (res.code == 200) {
          console.log(res.result.qrCode, "res.result");
          this.modeOfPaymentDialogVisible = true;
          // this.modeOfPaymentImg = res.result;
          setTimeout(() => {
            // this.modeOfPaymentSubmit(params);
            document.getElementById( 'qrCode' ).innerHTML =  ''
            new QRCode(this.$refs.qrCodeDiv, {
              text: res.result.qrCode,
              width: 200,
              height: 200,
              colorDark: "#333333", //二维码颜色
              colorLight: "#ffffff", //二维码背景色
              correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
            });
            this.qrCodeLoading = false;
            // 将支付和工单关联
            let par = {
              orderNo: params.orderNo,
              workNo: params.workNo,
            };
            this.$postJson("omc/api/relevanceWordNo", par).then((res) => {
              if (res.code == 200) {
                console.log(res, "??");
              }
            });
          }, 3000);
        } else {
          return this.$message.error(res.message);
        }
      });
    },
    // 取消支付
    callPay() {
      // 关闭二维码弹窗
      this.modeOfPaymentDialogVisible = false;
    },
    // 支付完成
    accomplishPay() {
      // 关闭二维码弹窗
      this.modeOfPaymentDialogVisible = false;
      // 关闭支付表单弹窗
      this.manualOperationRechargeDialogVisible = false;
      // 刷新数据
      this.onSubmit();
    },
    // 支付成功后处理事件
    modeOfPaymentSubmit(data) {
      setTimeout(() => {
        this.modeOfPaymentDialogVisible = false;
      }, "5000");
      // let params = Object.assign({}, this.manualOperationRecharge);
      let params = {
        orderNo: data.orderNo,
        investType: this.manualOperationRecharge.method,
        investAccount: data.investAccount,
        remark: data.remark,
      };
      console.log(params, "params");
      this.$postJson("omc/bankSarft/Balance/invest", params).then((res) => {
        if (res.code == 200) {
          this.loadingText = "交易成功,即将返回...";
          // this.$message.success(res.message);
          setTimeout(() => {
            this.manualOperationRechargeDialogVisible = false;
          }, 2000);
          // 刷新数据
          this.handleSearch();
        } else {
          this.$message.error(res.message);
          this.loadingText = "交易失败,请核对信息后重试...";
        }
      });
    },
    getAreaList(){
      this.$postJson('mdc/dict/queryDictSubListByDictCode/area_' + this.groupId).then(res=>{
        this.areaList = res.result;
      })
    }

  },
  created() {
    this.groupId = sessionStorage.getItem("groupId");
    this.getAreaList();
    this.$bus.$on("orderNumber", () => {
      this.queryList();
    });
  },
  mounted() {
    this.getUserData();
    this.queryList();
  },
};
</script>
<style lang="scss" scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
}
.demo-table-expand .el-form--inline .el-form-item__label {
  float: none;
  display: inline-block;
  color: #99a9bf;
  font-weight: 700;
}
.height40 {
  width: 135px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.height80 {
  width: 130px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
}
::deep.height40 {
  height: 40px;
  line-height: 40px;
  width: 80px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.colorBtn {
  background: rgb(165, 72, 241);
  color: #fff;
}
.red{
  color: red;
  font-size: 16px;
}
.labelOne {
  display: inline-block;
  width: 100px;
  margin-left: 10px;
  height: 20px;
  line-height: 20px;
  text-align: left;
}
.custom-tree-node-1 {
  display: inline-block;
  margin-left: 20px;
  width: 100px;
  text-align: left;
}
.custom-tree-node-show {
  display: inline-block;
  width: 100px;
  text-align: left;
  margin-left: 50px;
}
::deep .el-tree-node__content {
  height: 40px !important;
}
::deep
  .packagemanagement-tree
  .el-tree-node.is-current
  > .el-tree-node__content {
  background: #fff !important;
  color: #606266 !important;
  border-radius: 5px !important;
}
::deep .packagemanagement-tree .el-checkbox {
  height: 30px;
  line-height: 28px;
}
.img_box{
  flex:1;
  display:flex;
  height:40px;
  .img{
    width:38px;
    height:38px;
    margin:1px;
  }
}
.oldmanmap {
  margin: 0px;
  .map {
    width: 600px;
    height: 400px;
  }
}
//地图插件·
::deep .BMap_stdMpCtrl {
  top: 50px !important;
}
::deep .citylist_popup_main {
  margin-left: 45px;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: center;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
  font-size: 24px;
}
::deep.el-dialog-map .el-dialog__body {
  padding: 10px !important;
  display: flex;
  align-items: center;
}
::deep.el-form-item {
  margin-bottom: 8px !important;
}

::deep .el-dialog-map {
  .el-input__inner {
    width: 50%;
  }
}
.fenye {
  margin: 0px;
  padding: 30px 0;
  background: #fff;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
::deep .modeOfPaymentImg {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}
.toolbar ::deep .el-form-item{
  margin-bottom: 10px;
}
.worktable ::deep .el-table__expanded-cell{
  background-color: rgb(193, 214, 214);
}
::v-deep .demo-table-expand{
  padding-left: 40px;
}
::v-deep .el-form-item--small.el-form-item{
  margin-bottom: 8px;
}
::v-deep .el-form-item{
  margin-bottom: 10px;
}
</style>
